var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_83",
    "data-name": "Group 83",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.428,
    height: 25.364,
    viewBox: "0 0 34.428 25.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 7.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M18.21,157.077a1.957,1.957,0,0,1-2.032,0L0,147.2v13.129a5.083,5.083,0,0,0,5.081,5.081H29.347a5.083,5.083,0,0,0,5.081-5.081V147.2Z",
    transform: "translate(0 -147.2)",
    fill: "#df9426"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M31.232,57.088H6.966a5.051,5.051,0,0,0-4.918,3.983L19.12,71.477,36.151,61.071A5.051,5.051,0,0,0,31.232,57.088Z",
    transform: "translate(-2.048 -57.088)",
    fill: "#df9426"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.a7f2968d70f75c0197a8b1d8a42490ac.svg";
export { ForwardRef as ReactComponent };